import React, { Component } from "react";
import "./style.scss";
// import { Appointments, TreatmentHistory, PurchaseHistory, PersonalDetails, Favourites } from './Details'
import classnames from "classnames";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { NormalInput, NormalButton, TableWrapper } from "component/common";
import {
  getCommonApi,
  updateForm,
  commonCreateApi,
  commonDeleteApi,
  commonPatchApi,
} from "redux/actions/common";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PDFViewer, PDFDownloadLink, BlobProvider } from "@react-pdf/renderer";
import Invoice from "component/Admin/Report/Account/Invoice";
import { withTranslation } from "react-i18next";
import { Button, Form, FormGroup, Label, Input, FormText } from "reactstrap";

export class ProductPurchaseTabClass extends Component {
  state = {
    activeTab: "",
    isOpenTreatmentDone: false,
    isActiveTab: "detail",
    headerDetails: [
      { label: "Date ", width: "180px" },
      {
        label: "Transaction #",
        sortKey: false,
        width: "80px",
        // divClass: "justify-content-end text-right",
      },
      { label: "Item Desc", sortKey: false, width: "100px" },

      // { label: 'Package', sortKey: false, width: "75px" },
      { label: "Qty", sortKey: false, width: "150px" },

      {
        label: "Unit Price",
        sortKey: false,
        width: "100px",
        // divClass: "justify-content-end text-right",
      },
      {
        label: "Total Price",
        sortKey: false,
        width: "100px",
        // divClass: "justify-content-end text-right",
      },
      {
        label: "Staff Name ",
        sortKey: false,
        width: "100px",
      },

      { label: "", sortKey: false, width: "100px" },
    ],
    detailHeader: [
      {
        label: "Date",
        sortKey: false,
        width: "80px",
        divClass: "justify-content-end text-right",
      },
      { label: "Transaction #", sortKey: false, width: "180px" },
      { label: "Treatment #", width: "152px" },
      {
        label: "Payment",
        sortKey: false,
        width: "100px",
        divClass: "justify-content-end text-right",
      },
      {
        label: "Credit",
        sortKey: false,
        width: "100px",
        divClass: "justify-content-end text-right",
      },
      {
        label: "Outstanding",
        sortKey: false,
        width: "100px",
        divClass: "justify-content-end text-right",
      },
    ],
    olddetailHeader: [
      { label: "Date & Time", divClass: "justify-content-end text-right" },
      { label: "Description" },
      { label: "Hold Qty", divClass: "justify-content-end text-right" },
      { label: "Issued Qty", divClass: "justify-content-end text-right" },
      { label: "UOM" },
      { label: "Product Issue No." },
      { label: "Staff" },
      { label: "Site Code" },
      { label: "Status" },
    ],
    accountList: [],
    accountHeader: {},
    DetailList: [],
    isPrintPdfClick: false,
    oldDetailList: [],
    oldaccountHeader: {},
    page: 1,
    meta: {},
    isLoading: false,
    printAccountList: [],
  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  componentDidMount() {
    this.setState({
      isLoading: true,
    });
    this.getAccountData({});
    this.getPrintAccountData({});
  }

  getAccountDataOld = () => {
    let { accountHeader } = this.state;
    this.props
      .getCommonApi(`productpurchase/?cust_id=${this.props.id}`)
      .then((key) => {
        let { data, header_data } = key;
        let { accountList } = this.state;
        accountList = data;
        accountHeader = header_data;
        console.log(accountList, "accountListold");
        this.setState({ accountList, accountHeader });
      });
  };

  getAccountData = (data) => {
    this.setState({
      isLoading: true,
    });
    try {
      let { accountHeader, meta } = this.state;
      let { page = 1, limit = 24 } = data;
      this.props
        .getCommonApi(
          `productpurchase/?cust_id=${this.props.id}&page=${page}&limit=${limit}`
        )
        .then((key) => {
          let { data } = key;
          let { accountList } = this.state;
          accountList = data?.dataList;
          //accountHeader = header_data;
          //console.log(data.header_data.cust_name);
          accountHeader = {
            cust_name: data?.header_data?.cust_name,
          };
          meta = data?.pagination;
          this.setState({ accountList, accountHeader, meta });
          this.setState({
            isLoading: false,
          });
        });
    } catch (e) {
      this.setState({
        isLoading: false,
      });
    }
  };

  getPrintAccountData = (data) => {
    this.setState({
      isLoading: true,
    });
    try {
      let { printAccountList } = this.state;
      let { page = 1, limit = 1000 } = data;
      this.props
        .getCommonApi(
          `productpurchase/?cust_id=${this.props.id}
           &page=${page}&limit=${limit}`
        )
        .then((key) => {
          let { data } = key;
          printAccountList = data?.dataList;

          this.setState({ printAccountList });
          this.setState({
            isLoading: false,
          });
        });
    } catch (e) {
      this.setState({
        isLoading: false,
      });
    }
  };
  handlemainPagination = (page) => {
    this.getAccountData(page);
  };

  getAccountDataSal = () => {
    let { accountHeader, accountList, mainMeta } = this.state;

    this.props
      .getCommonApi(`productpurchase/?cust_id=${this.props.id}`)
      .then(async (key) => {
        await this.setState({
          accountList: [],
          mainMeta: {},
        });

        //.then(key => {
        let { data, header_data } = key;
        //let { accountList } = this.state;

        if (data) {
          let { dataList, meta } = data;
          if (dataList && dataList.length > 0) {
            accountList = data.dataList;
          }
          if (meta && meta.pagination) {
            mainMeta = data.meta.pagination;
          }

          console.log(accountList, "accountList");

          await this.setState({
            accountList,
            mainMeta,
          });
        }

        //accountList = data;
        accountHeader = header_data;
        //this.setState({ accountList, accountHeader }); //Yoonus added
        console.log(accountHeader, "accountHeader");
        this.setState({ accountHeader }); //Yoonus added
      });
  };

  handleOpenDetail = async (data, tab) => {
    let { activeTab } = this.state;
    activeTab = tab;

    await this.setState({
      activeTab,
    });
    if (tab === "detail") {
      this.getDetailList(data.id);
    } else {
      this.getOldDetailList(data.id);
    }
  };

  getDetailList = (id) => {
    this.props.getCommonApi(`productacclist/${id}`).then((key) => {
      let { data, header_data } = key;
      let { DetailList, accountHeader } = this.state;
      DetailList = data;
      accountHeader = header_data;
      this.setState({ DetailList, accountHeader });
    });
  };

  getOldDetailList = (id) => {
    this.props
      .getCommonApi(`productacclist/holditemacclist/?deposit_id=${id}`)
      .then((key) => {
        let { data, header_data } = key;
        let { oldDetailList, oldaccountHeader } = this.state;
        oldDetailList = data;
        oldaccountHeader = header_data;
        this.setState({ oldDetailList, oldaccountHeader });
      });
  };

  handleBack = () => {
    let { activeTab } = this.state;
    activeTab = "";
    this.setState({
      activeTab,
      DetailList: [],
    });
    this.getAccountData({});
  };
  handlePrintPdfFormat = (url) => {
    this.setState({
      isPrintPdfClick: false,
    });
    var a = document.createElement("a");
    a.setAttribute("download", `${new Date()}.pdf`);
    a.setAttribute("href", url);
    a.click();
    window.open(url);
  };

  render() {
    let {
      treatmentList,
      headerDetails,
      accountList = [],
      accountHeader = {},
      activeTab,
      detailHeader,
      DetailList,
      isPrintPdfClick,
      oldDetailList,
      olddetailHeader,
      oldaccountHeader,
      isLoading,
      meta,
      printAccountList,
    } = this.state;
    let {
      balance,
      outstanding,
      totalproduct_count,
      credit_balance,
      outstanding_balance,
      totalholdqty,
      sa_transacno_ref,
    } = accountHeader;
    let { t } = this.props;
    return (
      <div className="treatment-account">
        <div className="col-12 mt-2">
          <div className="table">
            {activeTab == "old" ? (
              <TableWrapper
                headerDetails={olddetailHeader}
                queryHandler={this.handlePagination}
                // pageMeta={pageMeta}
                // isEmpty={accountList.length === 0 ? true:false}
              >
                {oldDetailList && oldDetailList.length > 0
                  ? oldDetailList.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <div className="text-right">
                              {item.sa_date} {item.sa_time}
                            </div>
                          </td>
                          <td>
                            <div className="text-left">{item.hi_itemdesc}</div>
                          </td>
                          <td>
                            <div className="text-right">{item.holditemqty}</div>
                          </td>
                          <td>
                            <div className="text-right">{item.issued_qty}</div>
                          </td>
                          <td>
                            <div className="text-left">{item.hi_uom}</div>
                          </td>
                          <td>
                            <div className="text-left">
                              {item.product_issues_no}
                            </div>
                          </td>
                          <td>
                            <div className="text-left">{item.hi_staffname}</div>
                          </td>
                          <td>
                            <div className="text-left">
                              {item.itemsite_code}
                            </div>
                          </td>
                          <td>
                            <div className="text-left">{item.status}</div>
                          </td>
                        </tr>
                      );
                    })
                  : null}
              </TableWrapper>
            ) : activeTab == "detail" ? (
              <TableWrapper
                headerDetails={detailHeader}
                queryHandler={this.handlePagination}
              >
                {DetailList && DetailList.length > 0
                  ? DetailList.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <div className="text-right">{item.sa_date}</div>
                          </td>
                          <td>
                            <div className="text-left">{item.description}</div>
                          </td>
                          <td>
                            <div className="text-left">{item.type}</div>
                          </td>
                          <td>
                            <div className="text-right">
                              {"$" + item.payment}
                            </div>
                          </td>
                          <td>
                            <div className="text-right">
                              {"$" + item.balance}
                            </div>
                          </td>
                          <td>
                            <div className="text-right">
                              {"$" + item.outstanding}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  : null}
              </TableWrapper>
            ) : (
              <TableWrapper
                headerDetails={headerDetails}
                queryHandler={this.handlemainPagination}
                pageMeta={meta}
                // isEmpty={accountList.length === 0 ? true:false}
              >
                {isLoading ? (
                  <tr>
                    <td colSpan="12">
                      <div class="d-flex mt-5 align-items-center justify-content-center">
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : accountList && accountList.length > 0 ? (
                  accountList.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <div className="text-left">{item.sa_date}</div>
                        </td>
                        <td>
                          <div className="text-left">{item.transaction}</div>
                        </td>
                        <td>
                          <div className="text-left">{item.dt_itemdesc}</div>
                        </td>
                        <td>
                          <div className="text-left">{item.dt_qty}</div>
                        </td>

                        <td>
                          <div className="text-left">{item.dt_promoprice}</div>
                        </td>
                        <td>
                          <div className="text-left">{item.dt_transacamt}</div>
                        </td>

                        <td>
                          <div className="text-left">{item.dt_staffname}</div>
                        </td>
                        <td>
                          <div className="text-left"></div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="12">
                      <div className="d-flex fs-18 align-items-center justify-content-center">
                        {t("No data available")}
                      </div>
                    </td>
                  </tr>
                )}
              </TableWrapper>
            )}
          </div>
        </div>
        <div className="col-12 d-flex justify-center">
          {activeTab === "detail" || activeTab === "old" ? (
            <NormalButton
              buttonClass={"back mr-3"}
              mainbg={true}
              className="col-12 fs-15 "
              label="Back"
              onClick={() => this.handleBack()}
            />
          ) : (
            ""
          )}
          {activeTab === "old" ? null : (
            <NormalButton
              buttonClass={"print"}
              // mainbg={true}
              className="col-12 fs-15 "
              label="Print"
              // outline={false}
              onClick={() => this.setState({ isPrintPdfClick: true })}
            />
          )}
        </div>
        {isPrintPdfClick ? (
          <PDFDownloadLink
            document={
              <Invoice
                TableList={printAccountList}
                accountHeader={accountHeader}
                Flag={9}
                landscape={true}
              />
            }
          >
            {({ blob, url, loading, error }) =>
              !loading && url ? this.handlePrintPdfFormat(url) : null
            }
          </PDFDownloadLink>
        ) : null}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      updateForm,
      commonCreateApi,
      commonPatchApi,
      commonDeleteApi,
    },
    dispatch
  );
};

export const ProductPurchaseTab = withTranslation()(
  connect(null, mapDispatchToProps)(ProductPurchaseTabClass)
);
